<template>
  <div>
    <div id="act-fav-entry" />
    <div id="fixed-root" />
    <article id="app" class="tpl-wrap">
      <section
        style="min-width: 7.5rem"
        data-anchor="PM9sTrYwOWQr"
        data-fid="M9sTrYwOWQr"
        data-size="750|undefined"
        class="plat-section-outter-box container-wrapper"
      >
        <div
          class="t-space-container plat-section-space"
          style="
            padding-top: 0.3rem;
            padding-bottom: 1rem;
            padding-left: 0.2rem;
            padding-right: 0.2rem;
            width: 7.5rem;
          "
        >
          <div
            id="M9sTrYwOWQr"
            class="plat-section-inner-box a-wrap-module report-wrap-module report-scroll-module"
            data-container="section"
            data-version="0.0.2"
            data-module="rich-text-intl"
            scrollshow="true"
          >
            <div class="act-rich-style-init2">
              <div class="act-rich-render-content" style="line-height: 0">
                <p>
                  <span style="font-size: 0.24rem" class="content" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: 'DatadeletionManage',
  data() {
    return {
      content: {
        zh:
          '根据Facebook应用程序和网站平台规则，我们将提供用户数据删除回调URL或数据删除说明URL。如果您想删除蚂蚁剧场应用程序上的活动记录，可以按照以下步骤操作。' +
          '\n 1. 进入Facebook账户的“设置和隐私”，然后点击“设置”。' +
          '\n 2. 找到“应用程序和网站”后，您将看到所有链接至Facebook账户的应用程序和网站。' +
          '\n 3. 在搜索栏中搜索并点击“蚂蚁剧场”。' +
          '\n 4. 根据您的浏览偏好标记选项框，然后点击“删除”按钮。' +
          '\n 5. 恭喜！您已成功删除应用程序活动。',
        en:
          'According to the Facebook App and Website Platform Rules, we will provide a user data deletion callback URL or data deletion instructions URL. If you want to delete the activity records on the AntTV app, you can follow the steps below.' +
          '\n 1. Go to "Settings and Privacy" in your Facebook account and click "Settings".' +
          '\n 2. After finding "Apps and Websites", you will see all the apps and websites linked to your Facebook account.' +
          '\n 3. Search and click "AntTV" in the search bar.' +
          '\n 4. Mark the option box according to your browsing preferences and click the "Delete" button.' +
          '\n 5. Congratulations! You have successfully deleted the app activity.',
      },
    }
  },
  mounted() {
    !(function(doc, win, designWidth, rem2px) {
      function adapt(designWidth, rem2px) {
        var d = window.document.createElement('p')
        d.style.width = '1rem'
        d.style.display = 'none'
        var head = window.document.getElementsByTagName('head')[0]
        head.appendChild(d)
        var defaultFontSize = parseFloat(getComputedStyle(d).width)
        return defaultFontSize
      }
      function recalc() {
        var clientWidth =
          win.innerWidth ||
          doc.documentElement.clientWidth ||
          doc.body.clientWidth
        if (!clientWidth) return
        if (clientWidth < 750) {
          window.__BaseFontSize = (clientWidth / designWidth) * rem2px
          docEl.style.fontSize =
            (((clientWidth / designWidth) * rem2px) / defaultFontSize) * 100 +
            '%'
        } else {
          docEl.style.fontSize = '625%'
        }
      }
      var docEl = doc.documentElement
      var defaultFontSize = adapt(designWidth, rem2px)
      var resizeEvt =
        'orientationchange' in window ? 'orientationchange' : 'resize'
      if (!doc.addEventListener) return
      win.addEventListener(resizeEvt, recalc, false)
      recalc()
      // reset rem unit on page resize
      window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
          recalc()
        }
      })
      window.addEventListener('load', recalc)
      setTimeout(recalc, 500)
    })(document, window, 750, 100)
    const language = navigator.languages[1].includes('zh') ? 'zh' : 'en'
    console.log('current language:' + language)
    document.querySelector('.content').innerText = this.content[language]
  },
}
</script>

<style scoped>
.plat-fixed-box-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.fullpage-wrapper .plat-section-outter-box {
  overflow: auto;
}

.plat-fixed-outter-box {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  position: fixed;
  display: block;
}
.plat-fixed-inner-box {
  position: relative;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.plat-position-inner-box {
  position: relative;
  height: 100%;
  width: 100%;
}
.plat-position-outter-box {
  box-sizing: border-box;
  position: absolute;
  padding: 0;
  margin: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: auto;
}

.plat-position-outter-box .t-background-video {
  position: absolute;
  height: 100%;
  width: 100%;
}

.plat-section-outter-box {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  display: block;
}
/* #body-mobile .plat-section-outter-box {
        margin: -1px 0 0;
      } */

.plat-section-space {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  margin: 0 auto;
}

.plat-section-inner-box {
  position: relative;
  height: 100%;
}

.t-background-image {
  background-position: center;
  background-repeat: no-repeat;

  position: absolute;
  height: 100%;
  width: 100%;
}

#body-mobile .t-background-image,
.mobile .t-background-image {
  background-size: 100% auto;
}

.env-mobile .t-background-image,
.mobile .t-background-image {
  background-size: 100% 100%;
}
.fp-enabled .t-background-image,
.fullpage .mobile .t-background-image {
  background-size: cover;
}
</style>
